import { TFuncKey } from 'react-i18next'
import { snakeCase } from 'lodash'

import { FraudCheckType } from '@percent/admin-dashboard/api/types'

const fraudCheckTypeToTranslationGroup: Record<FraudCheckType, string> = {
  basic_domain_check: 'basicDomain',
  advanced_domain_check: 'advancedDomain',
  application_check: 'agent',
  document_check: 'document'
}

const snakeCaseOverrides: Record<string, string> = {
  anomalousApplicationVolumeByConfiguration1d: 'anomalous_application_volume_by_configuration_1d',
  anomalousApplicationVolumeByConfiguration7d: 'anomalous_application_volume_by_configuration_7d',
  anomalousApplicationVolumeByConfiguration30d: 'anomalous_application_volume_by_configuration_30d'
}

export function getFraudCheckTranslationKey(key: string, type: FraudCheckType) {
  const group = fraudCheckTypeToTranslationGroup[type]
  const baseKey = key.replace(/Check$/, '')
  const snakeKey = snakeCaseOverrides[baseKey] ?? snakeCase(baseKey)

  return `autoFraudChecks.${group}.${snakeKey}` as TFuncKey<'adminDashboard'>
}
